import { excluirAlert } from 'app/services/alerts';
import impostoApi from 'app/services/api/impostoApi';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { registroImposto } from '@core/util/mockTourUtils';

const BASE = '[IMPOSTO]';

const INITIAL_STATE = `${BASE} INITIAL_STATE`;
const MENSAGEM = `${BASE} MENSAGEM`;
const BUSCAR_REGISTROS = `${BASE} BUSCAR_REGISTROS`;
const CADASTRAR_REGISTRO = `${BASE} CADASTRAR_REGISTRO`;
const EDITAR_REGISTRO = `${BASE} EDITAR_REGISTRO`;
const VISUALIZAR_REGISTRO = `${BASE} VISUALIZAR_REGISTRO`;
const REMOVER_REGISTROS = `${BASE} REMOVER_REGISTROS`;
const SELECIONADOS = `${BASE} SELECIONADOS`;
const TIPO_SELECAO = `${BASE} TIPO_SELECAO`;
const CARREGANDO_REGISTROS = `${BASE} CARREGANDO_REGISTROS`;
const CARREGANDO_REGISTRO = `${BASE} CARREGANDO_REGISTRO`;
const FECHAR_MODAL_CADASTRO = `${BASE} FECHAR_MODAL_CADASTRO`;
const FECHAR_MODAL_VISUALIZACAO = `${BASE} FECHAR_MODAL_VISUALIZACAO`;
const SUCESSO = `${BASE} SUCESSO`;
const ERRO = `${BASE} ERRO`;
const REQUEST_PARAMS = `${BASE} REQUEST_PARAMS`;

export const ImpostoTypes = {
  INITIAL_STATE,
  MENSAGEM,
  BUSCAR_REGISTROS,
  CADASTRAR_REGISTRO,
  REMOVER_REGISTROS,
  EDITAR_REGISTRO,
  VISUALIZAR_REGISTRO,
  SELECIONADOS,
  TIPO_SELECAO,
  CARREGANDO_REGISTROS,
  CARREGANDO_REGISTRO,
  FECHAR_MODAL_CADASTRO,
  FECHAR_MODAL_VISUALIZACAO,
  SUCESSO,
  ERRO,
  REQUEST_PARAMS,
};

function setInitialState() {
  return {
    type: INITIAL_STATE,
  };
}

function setCurrentPage(page) {
  return {
    type: REQUEST_PARAMS,
    payload: { page },
  };
}
function setPageSize(size) {
  return {
    type: REQUEST_PARAMS,
    payload: { size },
  };
}
function setSorting(sort) {
  return {
    type: REQUEST_PARAMS,
    payload: { sort },
  };
}

function setQuery(q) {
  return {
    type: REQUEST_PARAMS,
    payload: { q },
  };
}

function setSelecionados(payload) {
  return {
    type: SELECIONADOS,
    payload,
  };
}

function setTipoSelecao(payload) {
  return {
    type: TIPO_SELECAO,
    payload,
  };
}

function setCarregandoRegistros(payload) {
  return {
    type: CARREGANDO_REGISTROS,
    payload,
  };
}

function setCarregandoRegistro(payload) {
  return {
    type: CARREGANDO_REGISTRO,
    payload,
  };
}

async function buscarRegistros(dispatch, params) {
  dispatch(setCarregandoRegistros(true));
  try {
    const response = await impostoApi.buscarImpostos(params);
    dispatch(ImpostoAction.setCurrentPage(params.page));
    dispatch(ImpostoAction.setPageSize(params.size));
    dispatch({ type: BUSCAR_REGISTROS, payload: { page: response.data } });
  } catch (error) {
    dispatch(erro(error?.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistros(false));
  }
}

async function buscarTour(dispatch) {
  dispatch(ImpostoAction.setCurrentPage(registroImposto.page));
  dispatch(ImpostoAction.setPageSize(registroImposto.size));
  dispatch({ type: BUSCAR_REGISTROS, payload: { page: registroImposto } });
}

async function visualizarRegistro(dispatch, imposto) {
  dispatch(setCarregandoRegistro(true));
  try {
    const response = await impostoApi.buscarImposto(imposto.id);
    dispatch({ type: VISUALIZAR_REGISTRO, payload: response.data });
  } catch (error) {
    dispatch(erro(error?.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function editarRegistro(dispatch, imposto) {
  dispatch(setCarregandoRegistro(true));
  try {
    const response = await impostoApi.buscarImposto(imposto.id);
    dispatch({ type: EDITAR_REGISTRO, payload: response.data });
  } catch (error) {
    dispatch(erro(error?.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function criarRegistro(dispatch, imposto, params) {
  dispatch(setCarregandoRegistro(true));
  try {
    const request = JSON.parse(JSON.stringify(imposto));

    request.fornecedorId = request.fornecedor?.id;
    delete request.fornecedor;

    eventReactGA('Imposto', 'Cadastrar imposto');
    await impostoApi.criarImposto(request);
    dispatch(sucesso('Imposto salvo com sucesso.', { cadastrar: false, visualizar: false }));
    buscarRegistros(dispatch, params);
  } catch (error) {
    dispatch(erro(error?.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function atualizarRegistro(dispatch, imposto, params) {
  dispatch(setCarregandoRegistro(true));
  try {
    const request = JSON.parse(JSON.stringify(imposto));

    request.fornecedorId = request.fornecedor?.id;
    delete request.fornecedor;

    eventReactGA('Imposto', 'Atualizar imposto');
    await impostoApi.atualizarImposto(imposto.id, request);
    dispatch(sucesso('Imposto editado com sucesso', { cadastrar: false, visualizar: false }));
    buscarRegistros(dispatch, params);
  } catch (error) {
    dispatch(erro(error?.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

function removerRegistros(dispatch, impostos = [], params) {
  const ids = impostos.map((imposto) => imposto.id);
  excluirAlert({
    confirmar: async () => {
      dispatch(setCarregandoRegistro(true));
      try {
        eventReactGA('Imposto', 'Excluir imposto');
        await impostoApi.removerImpostos({
          ids,
          q: params?.q,
          tipoSelecao: params?.tipoSelecao,
        });
        dispatch(sucesso('Imposto excluído com sucesso', { selecionados: [], tipoSelecao: 'NENHUM' }));
        buscarRegistros(dispatch, params);
      } catch (error) {
        dispatch(erro(error?.response?.data?.message));
      } finally {
        dispatch(setCarregandoRegistro(false));
      }
    },
  });
}

function setCadastrarRegistro() {
  return {
    type: CADASTRAR_REGISTRO,
  };
}

function setEditarRegistro(payload) {
  return {
    type: EDITAR_REGISTRO,
    payload,
  };
}

function fecharModalCadastro() {
  return {
    type: FECHAR_MODAL_CADASTRO,
  };
}

function fecharModalVisualizacao() {
  return {
    type: FECHAR_MODAL_VISUALIZACAO,
  };
}
function sucesso(message, props = {}) {
  return { type: SUCESSO, payload: { ...props, mensagem: { message, variant: 'success' } } };
}

function erro(message, props = {}) {
  return { type: ERRO, payload: { ...props, mensagem: { message, variant: 'error' } } };
}

export const ImpostoAction = {
  setInitialState,
  setSelecionados,
  setTipoSelecao,
  setCarregandoRegistros,
  setCarregandoRegistro,
  setEditarRegistro,
  setCadastrarRegistro,
  setCurrentPage,
  setPageSize,
  setSorting,
  setQuery,
  fecharModalCadastro,
  fecharModalVisualizacao,
  buscarRegistros,
  visualizarRegistro,
  criarRegistro,
  atualizarRegistro,
  removerRegistros,
  sucesso,
  erro,
  editarRegistro,
  buscarTour,
};
